import $ from "jquery";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaSearch, FaUserShield, FaUserPlus, FaTrash, FaCheck, FaTimes, FaCrown } from "react-icons/fa";
import CommonModal from "Components/CommonModal";
import Pagination from "Components/Pagination";
import AdminApplyModal from "Components/AdminApplyModal";
import {
  enterFn,
  commonModalSetting,
  changeState,
  catchError,
} from "JS/common";
import { getAdmin, adminDelete, adminMultiDelete } from "JS/API";
import { listPageStyles } from "utils/designSystem";

const AdminManage = () => {
  const [pageInfo, setPageInfo] = useState({
    page: 1,
    totalPage: 1,
    limit: 30, // 30개씩 보기
  });
  const [user, setUser] = useState([]);
  const [select, setSelect] = useState("all");
  const [searchTxt, setSearchTxt] = useState("");
  const [alert, setAlert] = useState("");
  const [alertBox, setAlertBox] = useState({
    mode: "",
    context: "",
    bool: false,
  });
  const [sortOrder] = useState({
    admin_role: "desc", // 'desc' 또는 'asc'
    created_at: "desc", // 'desc' 또는 'asc'
  }); // 정렬 순서
  const [mode, setMode] = useState("");
  const [deleteIdArr, setDeleteIdArr] = useState([]);
  const [deleteId, setDeleteId] = useState("");
  const [applyModal, setApplyModal] = useState(false);
  const [id, setId] = useState("");
  let prevent = false;
  const navigate = useNavigate();

  // 스타일 정의
  const styles = {
    container: listPageStyles.container,
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: '24px',
      flexWrap: 'wrap',
      gap: '16px'
    },
    title: listPageStyles.title,
    controlsWrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      alignItems: 'flex-end'
    },
    searchControls: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      flexWrap: 'wrap'
    },
    actionButtons: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      flexWrap: 'wrap'
    },
    select: listPageStyles.select,
    searchInput: {
      padding: '8px 12px',
      border: '1px solid #cbd5e1',
      borderRadius: '6px',
      fontSize: '14px',
      minWidth: '180px',
      color: '#1e293b',
      flexShrink: 1
    },
    searchButton: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '8px 16px',
      backgroundColor: '#3b82f6',
      color: '#ffffff',
      border: 'none',
      borderRadius: '6px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease'
    },
    deleteButton: listPageStyles.deleteButton,
    addButton: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '8px 16px',
      backgroundColor: '#10b981',
      color: '#ffffff',
      border: 'none',
      borderRadius: '6px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease'
    },
    tableContainer: listPageStyles.tableContainer,
    tableWrapper: listPageStyles.tableWrapper,
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      minWidth: '900px'
    },
    th: listPageStyles.th,
    td: listPageStyles.td,
    checkbox: listPageStyles.checkbox,
    roleSuper: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      color: '#dc2626',
      fontWeight: '600'
    },
    roleAdmin: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      color: '#3b82f6',
      fontWeight: '600'
    },
    statusActive: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      color: '#059669',
      fontWeight: '600'
    },
    statusInactive: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      color: '#dc2626',
      fontWeight: '600'
    },
    deleteButtonSmall: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      padding: '6px 12px',
      backgroundColor: '#ffffff',
      color: '#dc2626',
      border: '1px solid #dc2626',
      borderRadius: '4px',
      fontSize: '12px',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'all 0.2s ease'
    },
    emptyState: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '48px 24px',
      color: '#64748b',
      fontSize: '16px'
    }
  };

  // 관리자 페이지 로드시 정렬
  const sortUsers = (users) => {
    return [...users].sort((a, b) => {
      // admin_role 정렬
      if (a.admin_role === "super_admin" && b.admin_role !== "super_admin") {
        return sortOrder.admin_role === "desc" ? -1 : 1;
      }
      if (a.admin_role !== "super_admin" && b.admin_role === "super_admin") {
        return sortOrder.admin_role === "desc" ? 1 : -1;
      }

      // admin_role이 같은 경우 created_at으로 정렬
      const dateA = new Date(a.created_at);
      const dateB = new Date(b.created_at);
      return sortOrder.created_at === "desc" ? dateB - dateA : dateA - dateB;
    });
  };

  //= 관리자 불러오기
  const adminList = async () => {
    if (prevent) return;
    prevent = true;
    setTimeout(() => {
      prevent = false;
    }, 200);
    const result = await getAdmin(pageInfo, select, searchTxt);
    if (typeof result === "object") {
      const sortedData = sortUsers(result?.data?.data); // 정렬된 데이터 배열 반환
      setUser(sortedData); // 정렬된 데이터 배열 설정
      changeState(setPageInfo, "totalPage", result?.data?.meta?.total_page);
    } else return await catchError(result, navigate, setAlertBox, setAlert);
  };

  //= 관리자 삭제
  const deleteAdmin = async () => {
    const result = await adminDelete(deleteId);
    if (typeof result === "object") {
      setAlert("completeDelete");
      commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "정상적으로 삭제되었습니다."
      );
      setDeleteId(0);
    } else return await catchError(result, navigate, setAlertBox, setAlert);
  };

  //= 관리자 다중 삭제
  const duplicateDelete = async () => {
    const result = await adminMultiDelete(deleteIdArr);
    if (typeof result === "object") {
      setAlert("completeDelete");
      commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "정상적으로 삭제되었습니다."
      );
      setDeleteIdArr([]);
    } else return await catchError(result, navigate, setAlertBox, setAlert);
  };

  //= 전체 체크
  const checkAll = () => {
    let arr = [];
    if ($(".admin-all-check").is(":checked")) {
      $(".admin-check").prop("checked", true);
      const all = $(".admin-check").length;
      for (let i = 0; i < all; i++) {
        const val = document.getElementsByClassName("admin-check")[i].value;
        arr.push(val);
        setDeleteIdArr(arr);
      }
    } else {
      $(".admin-check").prop("checked", false);
      setDeleteIdArr([]);
    }
  };

  const renderAdminList = () => {
    return user.map(
      ({
        id,
        user_id,
        name,
        is_active,
        created_at,
        expired_at,
        admin_role,
      }) => {
        //= 각자 체크
        const checkEach = () => {
          let all = $(".admin-check").length;
          let checked = $(".admin-check:checked").length;
          let arr = [];
          if (all !== checked) $(".admin-all-check").prop("checked", false);
          else $(".admin-all-check").prop("checked", true);
          for (let i = 0; i < all; i++) {
            if (document.getElementsByClassName("admin-check")[i].checked) {
              const val =
                document.getElementsByClassName("admin-check")[i].value;
              arr.push(val);
              setDeleteIdArr(arr);
            }
          }
        };

        //= 모달 데이터 바인딩
        const onModal = () => {
          if (!is_active)
            return commonModalSetting(
              setAlertBox,
              true,
              "alert",
              "삭제된 관리자는 수정할 수 없습니다."
            );
          setId(id);
          setMode("edit");
          setApplyModal(true);
        };

        return (
          <tr 
            key={id}
            onMouseEnter={(e) => e.target.parentElement.style.backgroundColor = '#f8fafc'}
            onMouseLeave={(e) => e.target.parentElement.style.backgroundColor = 'transparent'}
          >
            <td style={styles.td} onClick={(e) => e.stopPropagation()}>
              {is_active ? (
                <input
                  type="checkbox"
                  className="admin-check"
                  value={id}
                  onChange={checkEach}
                  style={styles.checkbox}
                />
              ) : (
                ""
              )}
            </td>
            <td style={styles.td} onClick={onModal}>{user_id}</td>
            <td style={styles.td} onClick={onModal}>{name}</td>
            <td style={styles.td} onClick={onModal}>
              {admin_role === "super_admin" ? (
                <span style={styles.roleSuper}>
                  <FaCrown size={12} />
                  최상위 관리자
                </span>
              ) : (
                <span style={styles.roleAdmin}>
                  <FaUserShield size={12} />
                  관리자
                </span>
              )}
            </td>
            <td style={styles.td} onClick={onModal}>
              {is_active ? (
                <span style={styles.statusActive}>
                  <FaCheck size={12} />
                  회원
                </span>
              ) : (
                <span style={styles.statusInactive}>
                  <FaTimes size={12} />
                  탈퇴
                </span>
              )}
            </td>
            <td style={styles.td} onClick={onModal}>{created_at}</td>
            <td style={styles.td} onClick={onModal}>{is_active ? "" : expired_at}</td>
            <td style={styles.td}>
              {is_active ? (
                <button
                  style={styles.deleteButtonSmall}
                  onClick={() => {
                    setDeleteId(id);
                    setAlert("confirmDelete");
                    commonModalSetting(
                      setAlertBox,
                      true,
                      "confirm",
                      "정말 삭제하시겠습니까?"
                    );
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#dc2626';
                    e.target.style.color = '#ffffff';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#ffffff';
                    e.target.style.color = '#dc2626';
                  }}
                >
                  <FaTrash size={10} />
                  삭제
                </button>
              ) : (
                ""
              )}
            </td>
          </tr>
        );
      }
    );
  };

  useEffect(() => {
    document.title = "마크픽 관리자 > 관리자 계정 관리";
    if (localStorage.getItem("admin_role") === "admin") {
      setAlert("notAuthority");
      return commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "접근 권한이 없습니다."
      );
    }
    setSearchTxt("");
    if (!applyModal && select === "all") adminList();
  }, [pageInfo.page, pageInfo.limit, applyModal, select]);

  return (
    <div style={styles.container}>
      {/* 헤더 */}
      <div style={styles.header}>
        <h1 style={styles.title}>
          <FaUserShield />
          ADMIN
        </h1>
        
        <div style={styles.controlsWrapper}>
          {/* 검색 컨트롤 */}
          <div style={styles.searchControls} className="search-controls">
            <select
              value={pageInfo.limit}
              onChange={(e) => {
                setPageInfo((prev) => {
                  const clone = { ...prev };
                  clone.page = 1;
                  clone.limit = e.target.value;
                  return clone;
                });
              }}
              style={styles.select}
            >
              <option value="10">10명씩 보기</option>
              <option value="30">30명씩 보기</option>
              <option value="50">50명씩 보기</option>
            </select>
            
            <select
              value={select}
              onChange={(e) => setSelect(e.target.value)}
              style={styles.select}
            >
              <option value="all">전체 보기</option>
              <option value="uid">아이디</option>
              <option value="name">이름</option>
            </select>
            
            <input
              type="text"
              placeholder="검색어를 입력하세요."
              value={searchTxt}
              onChange={(e) => setSearchTxt(e.target.value)}
              onKeyDown={(e) => {
                if (!alertBox.bool) enterFn(e, () => {});
              }}
              style={styles.searchInput}
              className="search-input"
            />
            
            <button
              style={styles.searchButton}
              onClick={() => {
                if (select === "all")
                  commonModalSetting(
                    setAlertBox,
                    true,
                    "alert",
                    "검색하실 검색어의 종류를 선택해 주세요."
                  );
                else if (searchTxt.trim() === "")
                  commonModalSetting(
                    setAlertBox,
                    true,
                    "alert",
                    "검색어를 입력해 주세요."
                  );
                adminList();
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
            >
              <FaSearch />
              <span className="button-text">검색</span>
            </button>
          </div>

          {/* 액션 버튼 */}
          <div style={styles.actionButtons} className="action-buttons">
            <button
              style={styles.deleteButton}
              onClick={() => {
                if (!deleteIdArr.length)
                  return commonModalSetting(
                    setAlertBox,
                    true,
                    "alert",
                    "삭제할 대상을 선택해 주세요."
                  );
                else {
                  setAlert("confirmMultiDelete");
                  commonModalSetting(
                    setAlertBox,
                    true,
                    "confirm",
                    `${deleteIdArr.length}명의 관리자를 정말 삭제하시겠습니까?<br/>삭제된 관리자는 복구할 수 없습니다.`
                  );
                }
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#b91c1c'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#dc2626'}
            >
              <FaTrash />
              <span className="button-text">일괄 삭제</span>
            </button>
            
            <button
              style={styles.addButton}
              onClick={() => {
                setMode("apply");
                setApplyModal(true);
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#059669'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#10b981'}
            >
              <FaUserPlus />
              <span className="button-text">신규 관리자 등록</span>
            </button>
          </div>
        </div>
      </div>

      {/* 테이블 */}
      <div style={styles.tableContainer}>
        {user?.length ? (
          <div style={styles.tableWrapper} className="table-wrapper">
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>
                    <input
                      type="checkbox"
                      className="admin-all-check"
                      onChange={checkAll}
                      style={styles.checkbox}
                    />
                  </th>
                  <th style={styles.th}>아이디</th>
                  <th style={styles.th}>이름</th>
                  <th style={styles.th}>권한</th>
                  <th style={styles.th}>회원구분</th>
                  <th style={styles.th}>가입일</th>
                  <th style={styles.th}>탈퇴일</th>
                  <th style={styles.th}>관리자 삭제</th>
                </tr>
              </thead>
              <tbody>{renderAdminList()}</tbody>
            </table>
          </div>
        ) : (
          <div style={styles.emptyState}>목록이 없습니다.</div>
        )}
      </div>

      {/* 페이지네이션 */}
      <Pagination pageInfo={pageInfo} setPageInfo={setPageInfo} />

      {/* 모달들 */}
      {applyModal && (
        <AdminApplyModal setModal={setApplyModal} mode={mode} id={id} />
      )}
      {alertBox.bool && (
        <CommonModal
          setModal={setAlertBox}
          modal={alertBox}
          okFn={() => {
            if (alert === "confirmMultiDelete") duplicateDelete();
            else if (alert === "completeDelete") adminList();
            else if (alert === "confirmDelete") deleteAdmin();
            else if (alert === "notAuthority") navigate("/home");
            else if (alert === "logout") navigate("/");
            else return;
          }}
        />
      )}

      {/* 반응형 스타일 */}
      <style>{`
        @media (max-width: 1024px) {
          .search-controls {
            justify-content: flex-start;
          }
          
          .action-buttons {
            justify-content: flex-end;
          }
        }
        
        @media (max-width: 768px) {
          .table-wrapper {
            -webkit-overflow-scrolling: touch;
          }
          
          .table-wrapper::-webkit-scrollbar {
            height: 8px;
          }
          
          .table-wrapper::-webkit-scrollbar-track {
            background: #f1f5f9;
            border-radius: 4px;
          }
          
          .table-wrapper::-webkit-scrollbar-thumb {
            background: #cbd5e1;
            border-radius: 4px;
          }
          
          .table-wrapper::-webkit-scrollbar-thumb:hover {
            background: #94a3b8;
          }
        }
        
        @media (max-width: 640px) {
          .search-controls,
          .action-buttons {
            justify-content: center;
          }
          
          .search-input {
            min-width: 150px !important;
          }
          
          .button-text {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};

export default AdminManage;